(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/handlers/pix-handlers.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/handlers/pix-handlers.js');
"use strict";


const {
  http
} = svs.isServer ? require('../proxy-handler.es6') : svs.components.lbUtils.apiProxy;
const featureToggle = svs.isServer ? require('../feature-toggle.es6') : svs.components.lbUtils.apiProxy.featureToggle;
const {
  FEATURE_TOGGLE
} = svs.isServer ? require('../constants.es6') : svs.components.lbUtils.apiProxy.constants;
const PixURLPatterns = {
  PIX: '/wager/1/:product/pix',
  PIX_SINGLEROWS: '/wager/1/:product/pix/singlerows'
};
const PixCloudEndpointTemplates = {
  PIX: '/v1/pix/:product',
  PIX_SINGLEROWS: '/v1/pix/:product/singlerows'
};
const noTransformResolver = async _ref => {
  let {
    data
  } = _ref;
  return data;
};
const createPixHandlers = (allowedProducts, toggleName) => [http.post(PixURLPatterns.PIX, noTransformResolver, {
  config: {
    allowedProducts,
    cloudEndpointTemplate: PixCloudEndpointTemplates.PIX,
    preserveQuery: true,
    queryParamMappings: {
      systemNumberMapping: 'systemSize'
    },
    shouldUseCloud: async options => await featureToggle(toggleName, options)
  }
})];
const createPixSingleRowsHandlers = (allowedProducts, toggleName) => [http.post(PixURLPatterns.PIX_SINGLEROWS, noTransformResolver, {
  config: {
    allowedProducts,
    cloudEndpointTemplate: PixCloudEndpointTemplates.PIX_SINGLEROWS,
    preserveQuery: true,
    shouldUseCloud: async options => await featureToggle(toggleName, options)
  }
})];
const pixHandlers = [...createPixHandlers(['bomben'], FEATURE_TOGGLE.MARKETPLACE_BOMBEN_PIX_CLOUD_API), ...createPixHandlers(['challenge'], FEATURE_TOGGLE.MARKETPLACE_CHALLENGE_PIX_CLOUD_API), ...createPixHandlers(['europatipset'], FEATURE_TOGGLE.MARKETPLACE_EUROPATIPSET_PIX_CLOUD_API), ...createPixHandlers(['maltipset'], FEATURE_TOGGLE.MARKETPLACE_MALTIPSET_PIX_CLOUD_API), ...createPixHandlers(['matchen'], FEATURE_TOGGLE.MARKETPLACE_MATCHEN_PIX_CLOUD_API), ...createPixHandlers(['powerplay'], FEATURE_TOGGLE.MARKETPLACE_POWERPLAY_PIX_CLOUD_API), ...createPixHandlers(['stryktipset'], FEATURE_TOGGLE.MARKETPLACE_STRYKTIPSET_PIX_CLOUD_API), ...createPixHandlers(['topptipset', 'topptipsetextra', 'topptipsetstryk'], FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_PIX_CLOUD_API), ...createPixSingleRowsHandlers(['challenge'], FEATURE_TOGGLE.MARKETPLACE_CHALLENGE_PIX_CLOUD_API), ...createPixSingleRowsHandlers(['europatipset'], FEATURE_TOGGLE.MARKETPLACE_EUROPATIPSET_PIX_CLOUD_API), ...createPixSingleRowsHandlers(['maltipset'], FEATURE_TOGGLE.MARKETPLACE_MALTIPSET_PIX_CLOUD_API), ...createPixSingleRowsHandlers(['powerplay'], FEATURE_TOGGLE.MARKETPLACE_POWERPLAY_PIX_CLOUD_API), ...createPixSingleRowsHandlers(['stryktipset'], FEATURE_TOGGLE.MARKETPLACE_STRYKTIPSET_PIX_CLOUD_API), ...createPixSingleRowsHandlers(['topptipset', 'topptipsetextra', 'topptipsetstryk'], FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_PIX_CLOUD_API)];
if (svs.isServer) {
  module.exports = pixHandlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.handlers.pixHandlers', pixHandlers);
}

 })(window);